module.exports = __webpack_public_path__ + "assets/fielseg-alt.66fff2aa.svg";